<div class="container w-full flex justify-center items-center flex-col p-4">
    <section class="w-full h-9 flex justify-between items-center gap-8" *ngIf="totalComments > 0">
        <div class="ml-3 text-right text-sm font-semibold" >بر اساس {{ totalComments ?? 1 }} نظر </div>
        <div class="flex justify-between items-center cursor-pointer">
            <div class="w-full h-6 text-blue-500 hover:text-blue-400" (click)="showModalComments($event)">مشاهده همه نظرات</div>
            <div>
                <!-- <mat-icon matPrefix> -->
                    <i class="ico-Left text-2xl text-blue-500 hover:text-blue-400"></i>
                <!-- </mat-icon> -->
                </div>
        </div>
    </section>
    <div class="w-full h-0.5 bg-gray-200 rounded-full mt-3"></div>
    <section *ngIf="hotelInfoSummary.Type != 2" class="grid grid-cols-2 gap-3 w-full pt-5">
 
        <div *ngFor="let hotelReview of hotelReviewLabels">
            <div class="flex justify-between items-center w-40">
                <div class="text-[12px]">
                {{ hotelReview.fa }}
                </div>
                <div class="text-[14px]">
                {{ hotelReviewData()?.[hotelReview.en] ?? '3.3' }}
                </div>
            </div>
            <iho-progressbar
            [hasAnimation]="true"
            [progressValue]="hotelReviewData() ? +hotelReviewData()[hotelReview.en] : +'3.3'"
            [min]="0"
            [max]="5"/>
        </div>
    </section>
        <section *ngIf="hotelInfoSummary.Type == 2" class="grid grid-cols-2 gap-3 w-full pt-5">
        
            <div *ngFor="let ecolodgeReview of ecolodgeReviewLabels">
                <div class="flex justify-between items-center w-40">
                    <div class="text-[12px]">
                        {{ ecolodgeReview.fa }}
                    </div>
                    <div class="text-[14px]">
                        {{ hotelReviewData()?.[ecolodgeReview.en] ?? '3.3' }}
                    </div>
                </div>
                <iho-progressbar [hasAnimation]="true"
                    [progressValue]="hotelReviewData() ? +hotelReviewData()[ecolodgeReview.en] : +'3.3'" [min]="0" [max]="5" />
            </div>
        </section>
</div>
